module.exports = __webpack_public_path__ + "static/img/jylh.df711a96.png";